<template>
  <span :class="styles">{{ text }}</span>
</template>

<script>
import { css } from 'emotion'

export default {
  name: 'Status',
  props: {
    status: String,
    withColor: Boolean,
    withUnderline: Boolean,
    perspective: {
      type: String,
      default: 'all', // all|agency
    },
  },
  computed: {
    text() {
      switch (this.status) {
        case 'waiting':
          return this.perspective === 'all' ? '承認待ち' : '申請中'
        case 'approved':
          return '承認済'
        case 'rejected':
          return '却下'
        case 'cancel':
          return '取り消し'
        default:
          return this.status
      }
    },
    color() {
      switch (this.status) {
        case 'waiting':
          return 'orange'
        case 'approved':
          return 'blue'
        case 'rejected':
          return 'red'
        case 'cancel':
          return 'red'
        default:
          return 'inherit'
      }
    },
    styles() {
      if (!this.withColor) return
      return css`
        color: ${this.color};
        text-decoration-color: ${this.color};
        text-decoration: ${this.withUnderline ? 'underline' : 'none'};
      `
    },
  },
}
</script>
